module.exports = __webpack_public_path__ + "img/abBanner.d6c7bb1c.png";